import Vue from "vue";
import VueI18n from "vue-i18n";
import store from "@/store";
import { resetTextByCompany } from "@/utils/utils";

Vue.use(VueI18n);

import cn from "./cn";
// import en from "./en";
// import jp from "./jp";

const messages = {
  cn: { ...cn },
  // en: { ...en },
  // jp: { ...jp },
};

const i18n = new VueI18n({
  locale: "cn",
  fallbackLocale: "cn",
  messages,
});

const rawT = (i18n as any)._t.bind(i18n);
(i18n as any)._t = (key: string, ...args: any[]) => {
  const profile = store.getters.profile || {};
  return rawT(resetTextByCompany(profile.CompanyName || "", key), ...args);
};

const loadedLanguages = ["cn"]; // 我们的预装默认语言

function setI18nLanguage(lang: string) {
  i18n.locale = lang;
  return lang;
}

export function loadLanguageAsync(lang: string) {
  if (i18n.locale !== lang) {
    if (!loadedLanguages.includes(lang)) {
      return import(/* webpackChunkName: "lang-[request]" */ `@/lang/${lang}`).then(msgs => {
        i18n.setLocaleMessage(lang, msgs.default);
        loadedLanguages.push(lang);
        return setI18nLanguage(lang);
      });
    }
    return Promise.resolve(setI18nLanguage(lang));
  }
  return Promise.resolve(lang);
}
if (window.localStorage.lange && window.localStorage.lange != "cn") {
  loadLanguageAsync(window.localStorage.lange);
}

export default i18n;
